export const DIRECTORY_NAME_MAX_LENGTH = 200;

const PATH_SEPARATORS = /[/\\]/;
const PATH_SEPARATORS_GLOBAL = /[/\\]/g;
// eslint-disable-next-line no-control-regex -- matching control chars is the point
const CONTROL_CHARS = /[\x00-\x1f\x7f]/;
// eslint-disable-next-line no-control-regex -- matching control chars is the point
const CONTROL_CHARS_GLOBAL = /[\x00-\x1f\x7f]/g;

const RESERVED_NAMES = new Set([
  ".",
  "..",
  "con",
  "prn",
  "aux",
  "nul",
  ...Array.from({ length: 9 }, (_, i) => `com${i + 1}`),
  ...Array.from({ length: 9 }, (_, i) => `lpt${i + 1}`),
]);

// A fragment saying why `name` isn't a valid directory name, or null if it is.
// Callers prefix a subject, e.g. `Name ${error}.` or `it ${error}`.
export function directoryNameError(name: string): string | null {
  const trimmed = name.trim();
  if (trimmed.length === 0) return "can’t be empty";
  if (trimmed.length > DIRECTORY_NAME_MAX_LENGTH)
    return `must be ${DIRECTORY_NAME_MAX_LENGTH} characters or fewer`;
  if (PATH_SEPARATORS.test(trimmed)) return "can’t contain “/” or “\\”";
  if (CONTROL_CHARS.test(trimmed)) return "can’t contain control characters";
  if (trimmed.endsWith(".")) return "can’t end with a dot";
  if (RESERVED_NAMES.has(trimmed.toLowerCase())) return "is reserved";
  return null;
}

export function isValidDirectoryName(name: string): boolean {
  return directoryNameError(name) === null;
}

// Coerce arbitrary text into a valid directory name for callers that can't
// reject and re-prompt, falling back when nothing usable remains.
export function sanitizeDirectoryName(raw: string, fallback: string): string {
  const cleaned = raw
    .replace(PATH_SEPARATORS_GLOBAL, " ")
    .replace(CONTROL_CHARS_GLOBAL, "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, DIRECTORY_NAME_MAX_LENGTH)
    .replace(/\.+$/, "")
    .trim();
  if (cleaned.length === 0 || RESERVED_NAMES.has(cleaned.toLowerCase()))
    return fallback;
  return cleaned;
}
